import React from "react";

import previous from "svg/previous.svg";
import next from "svg/next.svg";

import "./style.scss";

const Pagination = ({
  currentButton,
  numberOfPages,
  arrOfCurrentButton,
  setCurrentButton,
  handlePrevious,
  handleNext,
}) => {
  return (
    <div className="pagination-list">
      <a
        className={`${currentButton === 1 ? "disabled" : ""} pagination-list__page pagination-list__page__first`}
        onClick={handlePrevious}
      >
        <img src={previous} alt="previous" />
      </a>
      {arrOfCurrentButton.map((page, i) => {
        return (
          <a
            key={i}
            className={`pagination-list__page ${
              currentButton === page ? "pagination-list__active" : "pagination-list__inactive"
            }`}
            onClick={() => setCurrentButton(page)}
          >
            <span className="pagination-list__page--number">{page}</span>
          </a>
        );
      })}
      <a
        className={`${
          currentButton === numberOfPages.length ? "disabled" : ""
        } pagination-list__page pagination-list__page__last`}
        onClick={handleNext}
      >
        <img src={next} alt="next" />
      </a>
    </div>
  );
};

export default Pagination;
